import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _createForOfIteratorHelper from "@babel/runtime-corejs2/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";

/* tslint:disable:no-any */
import debounce from 'lodash/debounce';
import { SessionManagerStateType } from '@central-products/interface-session-manager';
import { SESSION_MANAGER_BASE_STATE_EXTENSION } from '../constants';
import { MARK_ACTIVE_EVENT_NAMES } from './constants';
import { retryable, RetryableAbortedError } from '../libs/retryable';
import { HTTPError } from '../libs/http-error';
import { abortable } from '../libs/abortable';
export var SessionMarkActiveListenerServiceStrategy = /*#__PURE__*/function () {
  function SessionMarkActiveListenerServiceStrategy(config) {
    _classCallCheck(this, SessionMarkActiveListenerServiceStrategy);

    this.config = config;

    _defineProperty(this, "debouncedUpdate", void 0);

    _defineProperty(this, "debouncedUpdateBound", void 0);

    _defineProperty(this, "abortController", void 0);

    this.debouncedUpdate = debounce(this.updateInvoke, this.config.imAliveDebounceTime, {
      maxWait: this.config.imAliveDebounceMaxWaitTime
    });
    this.debouncedUpdateBound = this.debouncedUpdate.bind(this);
  }

  _createClass(SessionMarkActiveListenerServiceStrategy, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _iterator, _step, eventName;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iterator = _createForOfIteratorHelper(MARK_ACTIVE_EVENT_NAMES);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    eventName = _step.value;
                    window.addEventListener(eventName, this.debouncedUpdateBound);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                this.abortController = new AbortController();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _iterator2, _step2, eventName;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.debouncedUpdate.cancel();
                _iterator2 = _createForOfIteratorHelper(MARK_ACTIVE_EVENT_NAMES);

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    eventName = _step2.value;
                    window.removeEventListener(eventName, this.debouncedUpdateBound);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                if (this.abortController) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return");

              case 5:
                if (!this.abortController.signal.aborted) {
                  this.abortController.abort();
                }

                this.abortController = undefined;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.debouncedUpdate());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function update() {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "updateInvoke",
    value: function () {
      var _updateInvoke = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this = this;

        var response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return retryable( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          if (!_this.abortController.signal.aborted) {
                            _context4.next = 2;
                            break;
                          }

                          throw new RetryableAbortedError();

                        case 2:
                          return _context4.abrupt("return", abortable(function () {
                            return _this.config.casClient.imAlive();
                          }, {
                            signal: _this.abortController.signal
                          }));

                        case 3:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                })), {
                  delay: {
                    initialTime: 2000,
                    maxTime: 2000,
                    jitter: false
                  },
                  retry: {
                    maxTime: 10 * 1000,
                    predicate: function predicate(error) {
                      if (error instanceof DOMException && error.name === 'AbortError') {
                        return false;
                      }

                      if (error instanceof HTTPError) {
                        return error.status !== 401;
                      }

                      return !(error instanceof RetryableAbortedError);
                    }
                  }
                });

              case 3:
                response = _context5.sent;

                if (response.success) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt("return");

              case 6:
                this.config.onStateChangedCallback(SessionManagerStateType.LOGGED_IN, _Object$assign({
                  accessToken: null
                }, response.state));
                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](0);

                if (_context5.t0 instanceof HTTPError) {
                  this.config.onStateChangedCallback(SessionManagerStateType.NOT_LOGGED_IN, SESSION_MANAGER_BASE_STATE_EXTENSION);
                }

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 9]]);
      }));

      function updateInvoke() {
        return _updateInvoke.apply(this, arguments);
      }

      return updateInvoke;
    }()
  }]);

  return SessionMarkActiveListenerServiceStrategy;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TZXNzaW9uTWFya0FjdGl2ZUxpc3RlbmVyL1Nlc3Npb25NYXJrQWN0aXZlTGlzdGVuZXJTZXJ2aWNlU3RyYXRlZ3kudHMiXSwibmFtZXMiOlsiZGVib3VuY2UiLCJTZXNzaW9uTWFuYWdlclN0YXRlVHlwZSIsIlNFU1NJT05fTUFOQUdFUl9CQVNFX1NUQVRFX0VYVEVOU0lPTiIsIk1BUktfQUNUSVZFX0VWRU5UX05BTUVTIiwicmV0cnlhYmxlIiwiUmV0cnlhYmxlQWJvcnRlZEVycm9yIiwiSFRUUEVycm9yIiwiYWJvcnRhYmxlIiwiU2Vzc2lvbk1hcmtBY3RpdmVMaXN0ZW5lclNlcnZpY2VTdHJhdGVneSIsImNvbmZpZyIsImRlYm91bmNlZFVwZGF0ZSIsInVwZGF0ZUludm9rZSIsImltQWxpdmVEZWJvdW5jZVRpbWUiLCJtYXhXYWl0IiwiaW1BbGl2ZURlYm91bmNlTWF4V2FpdFRpbWUiLCJkZWJvdW5jZWRVcGRhdGVCb3VuZCIsImJpbmQiLCJldmVudE5hbWUiLCJ3aW5kb3ciLCJhZGRFdmVudExpc3RlbmVyIiwiYWJvcnRDb250cm9sbGVyIiwiQWJvcnRDb250cm9sbGVyIiwiY2FuY2VsIiwicmVtb3ZlRXZlbnRMaXN0ZW5lciIsInNpZ25hbCIsImFib3J0ZWQiLCJhYm9ydCIsInVuZGVmaW5lZCIsImNhc0NsaWVudCIsImltQWxpdmUiLCJkZWxheSIsImluaXRpYWxUaW1lIiwibWF4VGltZSIsImppdHRlciIsInJldHJ5IiwicHJlZGljYXRlIiwiZXJyb3IiLCJET01FeGNlcHRpb24iLCJuYW1lIiwic3RhdHVzIiwicmVzcG9uc2UiLCJzdWNjZXNzIiwib25TdGF0ZUNoYW5nZWRDYWxsYmFjayIsIkxPR0dFRF9JTiIsImFjY2Vzc1Rva2VuIiwic3RhdGUiLCJOT1RfTE9HR0VEX0lOIl0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUFBO0FBQ0EsT0FBT0EsUUFBUCxNQUFxQixpQkFBckI7QUFDQSxTQUFTQyx1QkFBVCxRQUF3Qyw2Q0FBeEM7QUFFQSxTQUFTQyxvQ0FBVCxRQUFxRCxjQUFyRDtBQUNBLFNBQVNDLHVCQUFULFFBQXdDLGFBQXhDO0FBQ0EsU0FBU0MsU0FBVCxFQUFvQkMscUJBQXBCLFFBQWlELG1CQUFqRDtBQUNBLFNBQVNDLFNBQVQsUUFBMEIsb0JBQTFCO0FBQ0EsU0FBU0MsU0FBVCxRQUEwQixtQkFBMUI7QUFPQSxXQUFhQyx3Q0FBYjtBQUtFLG9EQUNtQkMsTUFEbkIsRUFRRTtBQUFBOztBQUFBLFNBUGlCQSxNQU9qQixHQVBpQkEsTUFPakI7O0FBQUE7O0FBQUE7O0FBQUE7O0FBQ0EsU0FBS0MsZUFBTCxHQUF1QlYsUUFBUSxDQUFDLEtBQUtXLFlBQU4sRUFBb0IsS0FBS0YsTUFBTCxDQUFZRyxtQkFBaEMsRUFBcUQ7QUFDbEZDLE1BQUFBLE9BQU8sRUFBRSxLQUFLSixNQUFMLENBQVlLO0FBRDZELEtBQXJELENBQS9CO0FBR0EsU0FBS0Msb0JBQUwsR0FBNEIsS0FBS0wsZUFBTCxDQUFxQk0sSUFBckIsQ0FBMEIsSUFBMUIsQ0FBNUI7QUFDRDs7QUFsQkg7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLHVEQXFCNEJiLHVCQXJCNUI7O0FBQUE7QUFxQkksc0VBQWlEO0FBQXRDYyxvQkFBQUEsU0FBc0M7QUFDL0NDLG9CQUFBQSxNQUFNLENBQUNDLGdCQUFQLENBQXdCRixTQUF4QixFQUFtQyxLQUFLRixvQkFBeEM7QUFDRDtBQXZCTDtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQXlCSSxxQkFBS0ssZUFBTCxHQUF1QixJQUFJQyxlQUFKLEVBQXZCOztBQXpCSjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUE2QkkscUJBQUtYLGVBQUwsQ0FBcUJZLE1BQXJCO0FBN0JKLHdEQStCNEJuQix1QkEvQjVCOztBQUFBO0FBK0JJLHlFQUFpRDtBQUF0Q2Msb0JBQUFBLFNBQXNDO0FBQy9DQyxvQkFBQUEsTUFBTSxDQUFDSyxtQkFBUCxDQUEyQk4sU0FBM0IsRUFBc0MsS0FBS0Ysb0JBQTNDO0FBQ0Q7QUFqQ0w7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFBQSxvQkFtQ1MsS0FBS0ssZUFuQ2Q7QUFBQTtBQUFBO0FBQUE7O0FBQUE7O0FBQUE7QUF1Q0ksb0JBQUksQ0FBQyxLQUFLQSxlQUFMLENBQXFCSSxNQUFyQixDQUE0QkMsT0FBakMsRUFBMEM7QUFDeEMsdUJBQUtMLGVBQUwsQ0FBcUJNLEtBQXJCO0FBQ0Q7O0FBRUQscUJBQUtOLGVBQUwsR0FBdUJPLFNBQXZCOztBQTNDSjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSxrREErQ1csS0FBS2pCLGVBQUwsRUEvQ1g7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsdUJBb0R1RE4sU0FBUyx3RUFDeEQ7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLCtCQUlNLEtBQUksQ0FBQ2dCLGVBQUwsQ0FBc0JJLE1BQXRCLENBQTZCQyxPQUpuQztBQUFBO0FBQUE7QUFBQTs7QUFBQSxnQ0FLVSxJQUFJcEIscUJBQUosRUFMVjs7QUFBQTtBQUFBLDREQVFTRSxTQUFTLENBQUM7QUFBQSxtQ0FBTSxLQUFJLENBQUNFLE1BQUwsQ0FBWW1CLFNBQVosQ0FBc0JDLE9BQXRCLEVBQU47QUFBQSwyQkFBRCxFQUF3QztBQUFFTCw0QkFBQUEsTUFBTSxFQUFFLEtBQUksQ0FBQ0osZUFBTCxDQUFzQkk7QUFBaEMsMkJBQXhDLENBUmxCOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLGlCQUR3RCxJQVd4RDtBQUNFTSxrQkFBQUEsS0FBSyxFQUFFO0FBQ0xDLG9CQUFBQSxXQUFXLEVBQUUsSUFEUjtBQUVMQyxvQkFBQUEsT0FBTyxFQUFFLElBRko7QUFHTEMsb0JBQUFBLE1BQU0sRUFBRTtBQUhILG1CQURUO0FBTUVDLGtCQUFBQSxLQUFLLEVBQUU7QUFDTEYsb0JBQUFBLE9BQU8sRUFBRSxLQUFLLElBRFQ7QUFFTEcsb0JBQUFBLFNBQVMsRUFBRSxtQkFBQ0MsS0FBRCxFQUFXO0FBQ3BCLDBCQUFJQSxLQUFLLFlBQVlDLFlBQWpCLElBQWlDRCxLQUFLLENBQUNFLElBQU4sS0FBZSxZQUFwRCxFQUFrRTtBQUNoRSwrQkFBTyxLQUFQO0FBQ0Q7O0FBRUQsMEJBQUlGLEtBQUssWUFBWTlCLFNBQXJCLEVBQWdDO0FBQzlCLCtCQUFPOEIsS0FBSyxDQUFDRyxNQUFOLEtBQWlCLEdBQXhCO0FBQ0Q7O0FBRUQsNkJBQU8sRUFBRUgsS0FBSyxZQUFZL0IscUJBQW5CLENBQVA7QUFDRDtBQVpJO0FBTlQsaUJBWHdELENBcERoRTs7QUFBQTtBQW9EWW1DLGdCQUFBQSxRQXBEWjs7QUFBQSxvQkFzRldBLFFBQVEsQ0FBQ0MsT0F0RnBCO0FBQUE7QUFBQTtBQUFBOztBQUFBOztBQUFBO0FBMEZNLHFCQUFLaEMsTUFBTCxDQUFZaUMsc0JBQVosQ0FBbUN6Qyx1QkFBdUIsQ0FBQzBDLFNBQTNEO0FBQXdFQyxrQkFBQUEsV0FBVyxFQUFFO0FBQXJGLG1CQUE4RkosUUFBUSxDQUFDSyxLQUF2RztBQTFGTjtBQUFBOztBQUFBO0FBQUE7QUFBQTs7QUE0Rk0sb0JBQUksd0JBQWlCdkMsU0FBckIsRUFBZ0M7QUFDOUIsdUJBQUtHLE1BQUwsQ0FBWWlDLHNCQUFaLENBQW1DekMsdUJBQXVCLENBQUM2QyxhQUEzRCxFQUEwRTVDLG9DQUExRTtBQUNEOztBQTlGUDtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUEiLCJzb3VyY2VzQ29udGVudCI6WyIvKiB0c2xpbnQ6ZGlzYWJsZTpuby1hbnkgKi9cbmltcG9ydCBkZWJvdW5jZSBmcm9tICdsb2Rhc2gvZGVib3VuY2UnO1xuaW1wb3J0IHsgU2Vzc2lvbk1hbmFnZXJTdGF0ZVR5cGUgfSBmcm9tICdAY2VudHJhbC1wcm9kdWN0cy9pbnRlcmZhY2Utc2Vzc2lvbi1tYW5hZ2VyJztcbmltcG9ydCB7IENBU0NsaWVudCwgQ0FTQ2xpZW50SW1BbGl2ZVJlc3BvbnNlIH0gZnJvbSAnQGNlbnRyYWwtcHJvZHVjdHMvY2FzLWNsaWVudCc7XG5pbXBvcnQgeyBTRVNTSU9OX01BTkFHRVJfQkFTRV9TVEFURV9FWFRFTlNJT04gfSBmcm9tICcuLi9jb25zdGFudHMnO1xuaW1wb3J0IHsgTUFSS19BQ1RJVkVfRVZFTlRfTkFNRVMgfSBmcm9tICcuL2NvbnN0YW50cyc7XG5pbXBvcnQgeyByZXRyeWFibGUsIFJldHJ5YWJsZUFib3J0ZWRFcnJvciB9IGZyb20gJy4uL2xpYnMvcmV0cnlhYmxlJztcbmltcG9ydCB7IEhUVFBFcnJvciB9IGZyb20gJy4uL2xpYnMvaHR0cC1lcnJvcic7XG5pbXBvcnQgeyBhYm9ydGFibGUgfSBmcm9tICcuLi9saWJzL2Fib3J0YWJsZSc7XG5pbXBvcnQge1xuICBTZXNzaW9uTWFuYWdlck1hcmtBY3RpdmVMaXN0ZW5lckNvbmZpZyxcbiAgU2Vzc2lvbk1hbmFnZXJNYXJrQWN0aXZlTGlzdGVuZXJJbnRlcmZhY2UsXG4gIFNlc3Npb25NYW5hZ2VyU3RhdGVFeHRlbnNpb25UeXBlLFxufSBmcm9tICcuLi90eXBlcyc7XG5cbmV4cG9ydCBjbGFzcyBTZXNzaW9uTWFya0FjdGl2ZUxpc3RlbmVyU2VydmljZVN0cmF0ZWd5IGltcGxlbWVudHMgU2Vzc2lvbk1hbmFnZXJNYXJrQWN0aXZlTGlzdGVuZXJJbnRlcmZhY2Uge1xuICBwcml2YXRlIHJlYWRvbmx5IGRlYm91bmNlZFVwZGF0ZTogKCgpID0+IHZvaWQpICYgeyBjYW5jZWw6ICgpID0+IHZvaWQ7IGZsdXNoOiAoKSA9PiB2b2lkIH07XG4gIHByaXZhdGUgcmVhZG9ubHkgZGVib3VuY2VkVXBkYXRlQm91bmQ6ICgoKSA9PiB2b2lkKSAmIHsgY2FuY2VsOiAoKSA9PiB2b2lkOyBmbHVzaDogKCkgPT4gdm9pZCB9O1xuICBwcml2YXRlIGFib3J0Q29udHJvbGxlcj86IEFib3J0Q29udHJvbGxlcjtcblxuICBjb25zdHJ1Y3RvcihcbiAgICBwcml2YXRlIHJlYWRvbmx5IGNvbmZpZzogU2Vzc2lvbk1hbmFnZXJNYXJrQWN0aXZlTGlzdGVuZXJDb25maWcgJiB7XG4gICAgICBjYXNDbGllbnQ6IENBU0NsaWVudDtcbiAgICAgIG9uU3RhdGVDaGFuZ2VkQ2FsbGJhY2s6IChcbiAgICAgICAgc3RhdGU6IFNlc3Npb25NYW5hZ2VyU3RhdGVUeXBlLFxuICAgICAgICBzdGF0ZUV4dGVuc2lvbjogU2Vzc2lvbk1hbmFnZXJTdGF0ZUV4dGVuc2lvblR5cGVcbiAgICAgICkgPT4gdm9pZDtcbiAgICB9XG4gICkge1xuICAgIHRoaXMuZGVib3VuY2VkVXBkYXRlID0gZGVib3VuY2UodGhpcy51cGRhdGVJbnZva2UsIHRoaXMuY29uZmlnLmltQWxpdmVEZWJvdW5jZVRpbWUsIHtcbiAgICAgIG1heFdhaXQ6IHRoaXMuY29uZmlnLmltQWxpdmVEZWJvdW5jZU1heFdhaXRUaW1lLFxuICAgIH0pO1xuICAgIHRoaXMuZGVib3VuY2VkVXBkYXRlQm91bmQgPSB0aGlzLmRlYm91bmNlZFVwZGF0ZS5iaW5kKHRoaXMpO1xuICB9XG5cbiAgcHVibGljIGFzeW5jIHN0YXJ0KCkge1xuICAgIGZvciAoY29uc3QgZXZlbnROYW1lIG9mIE1BUktfQUNUSVZFX0VWRU5UX05BTUVTKSB7XG4gICAgICB3aW5kb3cuYWRkRXZlbnRMaXN0ZW5lcihldmVudE5hbWUsIHRoaXMuZGVib3VuY2VkVXBkYXRlQm91bmQpO1xuICAgIH1cblxuICAgIHRoaXMuYWJvcnRDb250cm9sbGVyID0gbmV3IEFib3J0Q29udHJvbGxlcigpO1xuICB9XG5cbiAgcHVibGljIGFzeW5jIHN0b3AoKSB7XG4gICAgdGhpcy5kZWJvdW5jZWRVcGRhdGUuY2FuY2VsKCk7XG5cbiAgICBmb3IgKGNvbnN0IGV2ZW50TmFtZSBvZiBNQVJLX0FDVElWRV9FVkVOVF9OQU1FUykge1xuICAgICAgd2luZG93LnJlbW92ZUV2ZW50TGlzdGVuZXIoZXZlbnROYW1lLCB0aGlzLmRlYm91bmNlZFVwZGF0ZUJvdW5kKTtcbiAgICB9XG5cbiAgICBpZiAoIXRoaXMuYWJvcnRDb250cm9sbGVyKSB7XG4gICAgICByZXR1cm47XG4gICAgfVxuXG4gICAgaWYgKCF0aGlzLmFib3J0Q29udHJvbGxlci5zaWduYWwuYWJvcnRlZCkge1xuICAgICAgdGhpcy5hYm9ydENvbnRyb2xsZXIuYWJvcnQoKTtcbiAgICB9XG5cbiAgICB0aGlzLmFib3J0Q29udHJvbGxlciA9IHVuZGVmaW5lZDtcbiAgfVxuXG4gIHB1YmxpYyBhc3luYyB1cGRhdGUoKTogUHJvbWlzZTxhbnk+IHtcbiAgICByZXR1cm4gdGhpcy5kZWJvdW5jZWRVcGRhdGUoKTtcbiAgfVxuXG4gIHByaXZhdGUgYXN5bmMgdXBkYXRlSW52b2tlKCkge1xuICAgIHRyeSB7XG4gICAgICBjb25zdCByZXNwb25zZTogQ0FTQ2xpZW50SW1BbGl2ZVJlc3BvbnNlID0gYXdhaXQgcmV0cnlhYmxlKFxuICAgICAgICBhc3luYyAoKSA9PiB7XG4gICAgICAgICAgLyoqXG4gICAgICAgICAgICogTWV0aG9kIGBzdG9wYCB3YXMgaW52b2tlZCBhbmQgYW55IGZ1cnRoZXIgY2FsbHMgc2hvdWxkIGJlIHByZXZlbnRlZC5cbiAgICAgICAgICAgKi9cbiAgICAgICAgICBpZiAodGhpcy5hYm9ydENvbnRyb2xsZXIhLnNpZ25hbC5hYm9ydGVkKSB7XG4gICAgICAgICAgICB0aHJvdyBuZXcgUmV0cnlhYmxlQWJvcnRlZEVycm9yKCk7XG4gICAgICAgICAgfVxuXG4gICAgICAgICAgcmV0dXJuIGFib3J0YWJsZSgoKSA9PiB0aGlzLmNvbmZpZy5jYXNDbGllbnQuaW1BbGl2ZSgpLCB7IHNpZ25hbDogdGhpcy5hYm9ydENvbnRyb2xsZXIhLnNpZ25hbCB9KTtcbiAgICAgICAgfSxcbiAgICAgICAge1xuICAgICAgICAgIGRlbGF5OiB7XG4gICAgICAgICAgICBpbml0aWFsVGltZTogMjAwMCxcbiAgICAgICAgICAgIG1heFRpbWU6IDIwMDAsXG4gICAgICAgICAgICBqaXR0ZXI6IGZhbHNlLFxuICAgICAgICAgIH0sXG4gICAgICAgICAgcmV0cnk6IHtcbiAgICAgICAgICAgIG1heFRpbWU6IDEwICogMTAwMCxcbiAgICAgICAgICAgIHByZWRpY2F0ZTogKGVycm9yKSA9PiB7XG4gICAgICAgICAgICAgIGlmIChlcnJvciBpbnN0YW5jZW9mIERPTUV4Y2VwdGlvbiAmJiBlcnJvci5uYW1lID09PSAnQWJvcnRFcnJvcicpIHtcbiAgICAgICAgICAgICAgICByZXR1cm4gZmFsc2U7XG4gICAgICAgICAgICAgIH1cblxuICAgICAgICAgICAgICBpZiAoZXJyb3IgaW5zdGFuY2VvZiBIVFRQRXJyb3IpIHtcbiAgICAgICAgICAgICAgICByZXR1cm4gZXJyb3Iuc3RhdHVzICE9PSA0MDE7XG4gICAgICAgICAgICAgIH1cblxuICAgICAgICAgICAgICByZXR1cm4gIShlcnJvciBpbnN0YW5jZW9mIFJldHJ5YWJsZUFib3J0ZWRFcnJvcik7XG4gICAgICAgICAgICB9LFxuICAgICAgICAgIH0sXG4gICAgICAgIH1cbiAgICAgICk7XG5cbiAgICAgIGlmICghcmVzcG9uc2Uuc3VjY2Vzcykge1xuICAgICAgICByZXR1cm47XG4gICAgICB9XG5cbiAgICAgIHRoaXMuY29uZmlnLm9uU3RhdGVDaGFuZ2VkQ2FsbGJhY2soU2Vzc2lvbk1hbmFnZXJTdGF0ZVR5cGUuTE9HR0VEX0lOLCB7IGFjY2Vzc1Rva2VuOiBudWxsLCAuLi5yZXNwb25zZS5zdGF0ZSB9KTtcbiAgICB9IGNhdGNoIChlcnJvcikge1xuICAgICAgaWYgKGVycm9yIGluc3RhbmNlb2YgSFRUUEVycm9yKSB7XG4gICAgICAgIHRoaXMuY29uZmlnLm9uU3RhdGVDaGFuZ2VkQ2FsbGJhY2soU2Vzc2lvbk1hbmFnZXJTdGF0ZVR5cGUuTk9UX0xPR0dFRF9JTiwgU0VTU0lPTl9NQU5BR0VSX0JBU0VfU1RBVEVfRVhURU5TSU9OKTtcbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cbiJdfQ==